module.exports = __webpack_public_path__ + "img/Water-Polo.1b0824ad.png";